export default __webpack_public_path__ + "static/media/folio-icon.a6d71a61.svg";